import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import JournalTableRows from "./JournalTableRows";

import axios from "axios";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  AWS_IMAGE_FOLDER_CUSTOMER,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import * as Yup from "yup";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import moment from "moment";
import FileInput from "../../../../components/FormControls/FileInput";
import { uploadAWS } from "../../../../common/AWSHelper";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";
// The below variable are for permission given to the Functionalities

const JournalEntry = (props) => {
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(moment().format("MM-DD-YYYY"));
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [btnLoader, setBtnLoader] = useState({ Attachments: false });
  const [ImageUrl, setImageUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [isChecked, setIsChecked] = useState(0);
  const [credit, setCredit] = useState(0);
  const [debit, setDebit] = useState(0);
  const navigate = useNavigate();
  const { id } = useParams();
  const LocationId = localStorage.getItem("Location");

  //Setting the default date as a today's date
  const today = moment();
  console.log(today.format("YYYY-MM-DD"), "today");
  // formvalues
  const [formValues, setFormValues] = useState({
    Date: (moment().format('YYYY-MM-DDT00:00:00.000') + 'Z'),
    // Date: today.format("YYYY-MM-DD"),
    JournalNo: "",
    EntryCheck: "",
    Memo: "",
    SelectImage: "",
  });

  console.log(formValues.Date , "formValues--->")

  const [journalquickbookid, setJournalQuickbookId] = useState(0);

  const handleBirthday = (e) => {
    console.log(e.target.value, "event");
    setDate(moment(e.target.value).format("MM/DD/YYYY"));
  };

  const [rowsData, setRowsData] = useState(
    Array.from({ length: 8 }, (e, index) => ({
      id: 0,
      journalitemid: 0,
      accountid: "",
      debits: "",
      credits: "",
      description: "",
      userid: "",
      usertype: "",
      customerorsupplierid: 0,
      journalentryquickbookid: 0,
      userquickbookid: 0,
      AccountName: "",
      accountquickbookid: 0,
      rowNumber: index + 1,
    }))
  );
  const addTableRows = () => {
    const rowsInput = {
      journalitemid: 0,
      accountid: "",
      debits: "",
      credits: "",
      description: "",
      userid: "",
      usertype: "",
      customerorsupplierid: 0,
      journalentryquickbookid: 0,
      userquickbookid: 0,
    };

    setRowsData([...rowsData, rowsInput]);
  };

  console.log("rowsData 70", rowsData);

  const validationSchema = Yup.object().shape({
    Date: Yup.string().required("Date is required"),
    JournalNo: Yup.string().required("Journal No is required"),
  });

  const deleteTableRows = (i) => {
    const filteredData = rowsData.filter((item, index) => index !== i);
    setRowsData([]);

    console.log(filteredData, "filteredDatadelete");
      setTimeout(() => {
        setRowsData(filteredData);
      }, 500);
  };

  console.log(rowsData, "rowsData34");

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const handleMemoChange = (event) =>{
    setFormValues({
      ...formValues,
      Memo: event.target.value
    });
  }

  const handleChangeTableRow = (index, evnt) => {
    let id, name, values, quickbookid;

    name = evnt.target.name;
    values = evnt.target.value;
    // quickbookid= evnt.target.quickbookid;
    console.log(name, values);
    const rowsInput = [...rowsData];
    rowsInput[index][name] = values;
    if (name == "accountid") {
      rowsInput[index]["accountquickbookid"] = evnt.target.quickbookid;
      rowsInput[index]["AccountName"] = evnt.target.AccountName;
    }
    if (name == "userid") {
      rowsInput[index]["userquickbookid"] = evnt.target.appointmentquickbookid;
      rowsInput[index]["customerorsupplierid"] = evnt.target.IsCustomer;
    }
    setRowsData(rowsInput);
  };

  const handleSelectSevies = (e) => {
    console.log(e.target.checked);
    setIsChecked(e.target.checked === true ? 1 : 0);
  };

  const callback = (value, field) => {
    if (field == "credit") {
      setCredit(value);
    }

    if (field == "debit") {
      setDebit(value);
    }
  };


  const handleSubmit = (values) => {
    let result = rowsData.filter((item) => item.accountid > 0);

    console.log(result, "result0458");

    const filtereddata = result.filter((item) => {
      return (
        (item?.AccountName === "Accounts Payable (A/P)" ||
          item?.AccountName === "Accounts Receivable (A/R)") &&
        item.userid == ""
      );
    });

    const val = filtereddata.length > 0 ? true : false;

    console.log(filtereddata, val, "result0458 filter");
    // return;

    if (debit == credit && val == false) {
      console.log("values ==> ", values);
      console.log("isChecked ==> ", isChecked);
      // let data = rowsData.filter(function (rowData) {
      //   return rowData.name != "";
      // });

      let changedData = result.map(change => ({
        ...change,
        usertype: change.usertype === 1 ? "Customer" :
                  change.usertype === 0 ? "Supplier" :
                  change.usertype === 2 ? "Employee" :
                  ""
    }));

      console.log(changedData, "changeddata");

      const jsonobj = {};
      jsonobj.journalitemxml = changedData;

      let jsonstring = JSON.stringify(jsonobj);

      console.log("jsonstring ==> ", jsonstring);

      setLoading(true);

      axios
        .post(
          `${config.accountingBaseUrl}/chartofaccounts/journalupsert`,
          {
            xmljournalitems: jsonstring,
            id: id > 0 ? Number(id) : 0,
            journalno: values.JournalNo,
            journaldate: moment(values.Date).format("YYYY-MM-DD"),
            isadjustingjournalentry: isChecked,
            memo: values.Memo,
            journalattachmenturl: ImageUrl,
            totaldebitamount: debit,
            totalcreditamount: credit,
            loginuserid: loginUserId,
            locationid: LocationId,
            journalquickbookid: journalquickbookid,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            toastSuccess(SUCCESS_MESSAGE);

            console.log("values.buttonType 214", values.buttonType);

            if (values.buttonType === "saveAndClose") {
              navigate("/journals");
            } else {
              // Clear the form values to save & new
              navigate("/journal-entry");
              window.location.reload();

              // setFormValues({
              //   Date: (moment().format('YYYY-MM-DDT00:00:00.000') + 'Z'),
              //   JournalNo: "",
              //   EntryCheck: "",
              //   Memo: "",
              //   SelectImage: "",
              // });
              // setImageUrl("");
              // handleSaveChange();
              // setSelectedImage("");
              // setChangeImagename("");
              // setRowsData(Array.from({ length: 8 }, (e, index) => ({
              //   id: 0,
              //   journalitemid: 0,
              //   accountid: "",
              //   debits: "",
              //   credits: "",
              //   description: "",
              //   userid: "",
              //   usertype: "",
              //   customerorsupplierid: 0,
              //   journalentryquickbookid: 0,
              //   userquickbookid: 0,
              //   AccountName: "",
              //   accountquickbookid: 0,
              //   rowNumber: index + 1,
              // })))
              // window.location.reload(true);
            }
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError("Name" + ALREADY_EXIST);
          } else {
            toastError(ERROR_MESSAGE);
          }

          setLoading(false);

          // window.location.reload();
        })
        .catch((error) => {
          setLoading(false);
        });
    } else if (val == true) {
      toastError(
        "Need to Require Select Name where Account is Accounts Payable (A/P) and Accounts Receivable (A/R)"
      );
    } else {
      toastError("Your Credit & Debit Amount Should be Equal");
    }
  };

  useEffect(() => {
    if (id > 0) {
      setLoading(true);

      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/journalfindbyid?id=${id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const newfiltereddata = res.data.ResponseData.JournalItems?.map(
            (item, index) => {
              return {
                id: item.ID,
                journalitemid: item.ID,
                accountid: item.AccountID,
                debits: parseFloat(item.DebitAmount).toFixed(2),
                credits: parseFloat(item.CreditAmount).toFixed(2),
                description: item.Description,
                userid: item.UserID,
                usertype: item.UserType == "Customer" ? 1 : 0,
                userquickbookid: item.UserQuickbookId,
                accountquickbookid: item.AccountQuickbookId,
                journalitemsquickbookid: item.JournalItemsQuickbookId,
                customerorsupplierid: item.UserType == "Customer" ? 1 : 0,
              };
            }
          );
          setRowsData(newfiltereddata);

          const filtereddata = res.data.ResponseData.Journal[0];
          console.log(filtereddata.JournalDate , "filtereddata")
          setJournalQuickbookId(filtereddata.JournalQuickbookId);
          setFormValues({
            // Date: moment(filtereddata.JournalDate).format("YYYY-MM-DD"),
            Date: filtereddata.JournalDate,
            JournalNo: filtereddata.JournalNo,
            EntryCheck: "",
            Memo: filtereddata.Memo,
            SelectImage: filtereddata?.Attachments,
          });
          setImageUrl(filtereddata?.Attachments);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }, []);

  useEffect(() => {
    if (id == undefined) {
      setLoading(true);

      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/journalautoincerment`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // Date: "",
          // JournalNo: "",
          // EntryCheck: "",
          // Memo: "",
          // SelectImage: "",
          setFormValues({
            ...formValues,
            JournalNo: res.data.ResponseData[0].JournalNo,
            
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, []);

  
  const handledatechange = (event) => {
    console.log(event , "123000000")

    setFormValues(prev => { return {...prev , Date:event}});
  }

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h2 className="page-title">Accounting: Journal Entry</h2> */}
              <ul className="breadcrumb" style={{ marginLeft: "12px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">Journal Entry</li>
              </ul>
            </div>
          </div>

          <div className="card">
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange, setFieldValue }) => (
                <Form>
                  <div className="card-header mt-2">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Journal Date
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-7">
                            {/* <Flatpickr
                              type="date"
                              className={`form-control form-control-sm ${
                                errors.Date ? "is-invalid" : ""
                              }`}
                              // onChange={handleChange}
                              onChange={(event) => {
                                console.log(event , "DateEvent")
                                formValues.Date = event[0];
                              }}
                              // onChange={(e)=>handleBirthday(e)}
                              // defaultValue={date}
                              id="Date"
                              name="Date"
                              value={formValues?.Date}
                              options={{
                                dateFormat: "m/d/Y",
                                altInput: true,
                                altFormat: "m/d/Y",
                              }}
                            /> */}

<CommonDatePicker FinalDate={formValues.Date} handleDateChange={handledatechange}/>

                            {/* <input
                            type="date"
                            className={`form-control ${
                              errors.Date ? "is-invalid" : ""
                            }`}
                            // className="form-control"
                            // className="form-control form-control-sm"
                            onChange={(e)=>handleBirthday(e)}
                            id="Date"
                            name="Date"
                            /> */}
                            <div className="invalid-feedback">
                              {touched.Date && errors.Date ? errors.Date : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group row">
                          <label className="col-form-label col-md-4 form-label">
                            Journal No.
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-7">
                            <Field
                              type="number"
                              className={`form-control form-control-sm ${
                                errors.JournalNo ? "is-invalid" : ""
                              }`}
                              onChange={handleChange}
                              id="JournalNo"
                              name="JournalNo"
                            
                              
                            />
                            <div className="invalid-feedback">
                              {touched.JournalNo && errors.JournalNo
                                ? errors.JournalNo
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* <div className="col-sm-4">
                        <div className="form-group row">
                          <label className="col-form-label col-md-7 form-label">
                            Is Adjusting Journal Entry?
                          </label>
                          <div className="col-md-2 mt-1">
                            <Field
                              type="checkbox"
                              className="form-check-input"
                              style={{ width: "1.25em", height: "1.25em" }}
                              onChange={handleChange}
                              onInput={handleSelectSevies}
                              id="EntryCheck"
                              name="EntryCheck"
                              // disabled
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="">
                      <table className="table">
                        <thead>
                          <tr>
                            <th className="p-regular" width="25%">
                              Account
                              <span className="text-danger ml-1">*</span>
                            </th>
                            <th className="p-regular" width="15%">
                              Debits
                            </th>
                            <th className="p-regular" width="15%">
                              Credits
                            </th>
                            <th className="p-regular" width="15%">
                              Description
                            </th>
                            <th className="p-regular" width="20%">
                              Name
                            </th>
                            <th className="p-regular" width="5%">
                              Delete
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <JournalTableRows
                            rowsData={rowsData}
                            deleteTableRows={deleteTableRows}
                            handleChange={handleChangeTableRow}
                            callback={callback}
                          />
                        </tbody>
                        <tfoot>
                          <tr>
                            <td></td>
                            <td>Debit Total: {debit}</td>
                            <td>Credit Total: {credit}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>

                    <div className="form-group row mb-4">
                      <div className="col-sm-6 ">
                        <button
                          type="button"
                          className="btn btn-secondary mt-1  btn-sm pull-left mt-3"
                          onClick={addTableRows}
                          disabled={rowsData.length == 30 ? true : false}
                        >
                          <i className="fa fa-plus fa-sm " /> Add
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-2 form-label">
                            Memo
                          </label>
                          <div className="col-md-10 mt-2">
                            <Field
                              as="textarea"
                              id="Memo"
                              name="Memo"
                              rows={4}
                              cols={4}
                              onChange={handleMemoChange}
                              value={formValues?.Memo}
                            />
                          </div>
                        </div>
                      </div>

                      {/* row 5 */}
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-3 form-label">
                            Attachments
                          </label>
                          <div className="col-md-9">
                            <FileInput
                              id="SelectImage"
                              name="SelectImage"
                              value={selectedImage}
                              accept="image/*"
                              handleChange={_handleFileChange}
                              className="form-control form-control-sm"
                            />
                            {ImageUrl && (
                              <Link to={ImageUrl} target="_blank">
                                Attachment Link
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="row">
                      <div className="col-sm-6">
                        <div
                          className={`${
                            ImageUrl ? "" : selectedImage ? "" : "d-none"
                          } form-group row`}
                        >
                          <label className="col-form-label col-md-4 form-label"></label>
                          <div className="col-md-8">
                            <img
                              src={`${ImageUrl ? ImageUrl : selectedImage}`}
                              alt="Category Image"
                              className="ImagePreviewSize"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6"></div>
                    </div> */}

                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndClose");
                        }}
                      >
                        Save & Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-sm btn-secondary mt-3 mb-3"
                        onClick={() => {
                          setFieldValue("buttonType", "saveAndNew");
                        }}
                      >
                        Save & New
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default JournalEntry;
